import { useEffect, useContext, useState } from 'react';
import { ComponentContext } from '../Context/ComponentContext';
export function useUser() {
    const { authClient } = useContext(ComponentContext);
    const [user, setUser] = useState(null);
    useEffect(() => {
        authClient.getUser().then(setUser);
    }, [authClient]);
    return user;
}
//# sourceMappingURL=useUser.js.map